'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'floppy-disk';
var width = 448;
var height = 512;
var aliases = [128190,128426,"save"];
var unicode = 'f0c7';
var svgPathData = ['M48 80l0 352 352 0 0-265.4-80-80 0 121.4-224 0 0-128-48 0zM288 320a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z', 'M342.6 41.4L333.3 32 0 32 0 480 448 480 448 146.7 342.6 41.4zM320 86.6l80 80 0 265.4-352 0 0-352 48 0 0 128 224 0 0-121.4zM144 80l128 0 0 80-128 0 0-80zM288 320a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFloppyDisk = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;